<div
    class="itsl-common-loading-state-bounce"
    class:itsl-common-loading-state-bottompadding={useBottomPadding}>
    <div class="itsl-common-loading-state-bounce1"></div>
    <div class="itsl-common-loading-state-bounce2"></div>
    <div class="itsl-common-loading-state-bounce3"></div>
</div>

<script>
    export let useBottomPadding = true;
</script>
